import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { GetMainContactResponse } from '@/api/my-business/agency-chains/get-main-contact'

interface MockGetAgencyChainMainContactPathParams {
  agencyChainAlphaId: string
}

export const mockGetAgencyChainMainContact =
  http.get<MockGetAgencyChainMainContactPathParams>(
    '/my-business/api/agency/v1/agency-chains/:agencyChainAlphaId/contacts',
    () => {
      const response: GetMainContactResponse = {
        address: {
          address: faker.location.streetAddress(),
          neighborhood: faker.lorem.word(),
          zipCode: faker.address.zipCode(),
          cityId: faker.number.int({ min: 1000, max: 9999 }),
          departmentEnum: 'MAIN',
          description: faker.lorem.sentence(),
          number: faker.number.int({ min: 1, max: 999 }).toString(),
          complement: faker.lorem.sentence(),
        },
        departmentCode: 'MAIN',
        email: faker.internet.email(),
        name: faker.person.fullName(),
        phone: faker.phone.number(),
      }

      return HttpResponse.json(response, { status: 200 })
    },
  )
